export const documentTpeEnum = {
  Contract: 'Contract',
  Resume: 'Resume',
  Nda: 'Nda',
  Educational: 'Educational',
};
